import { Component, inject } from '@angular/core';
import { RouterOutlet, Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { filter, map, startWith } from 'rxjs/operators';
import { OrgManagementStateService } from '../../services/organization/org-management-state.service';
import { OrgManagementTabsComponent } from './org-management-tabs/org-management-tabs.component';

@Component({
  selector: 'app-org-management',
  standalone: true,
  imports: [RouterOutlet, OrgManagementTabsComponent, AsyncPipe, NgTemplateOutlet],
  providers: [OrgManagementStateService],
  templateUrl: './org-management.component.html',
  styleUrl: './org-management.component.css',
})
export class OrgManagementComponent {
  private stateService = inject(OrgManagementStateService);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  headerActions$ = this.stateService.headerActions$;
  pageTitle$ = this.router.events.pipe(
    filter((e): e is NavigationEnd => e instanceof NavigationEnd),
    startWith(null),
    map(() => {
      const path = this.activatedRoute.snapshot.firstChild?.routeConfig?.path;
      return path === 'quotas' ? $localize`Organization Management` : $localize`Organization Management`;
    })
  );
}
